<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{$ml.get('shared.support')}}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{$ml.get('shared.dashboard')}}</span>
        </li>
        <li>
          <i class="fa fa-cogs"></i>
          <span>{{$ml.get('shared.settings')}}</span>
        </li>
        <li>
          <span>{{$ml.get('shared.support')}}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-12" align="center">
          <h3>{{$ml.get('support.whatWouldYouLikeSupportOn')}}</h3>
          <div class="input-group" style="margin-bottom:7px; width:70%;">
            <input
              type="text"
              :placeholder="$ml.get('support.subjectYouWantHelpWith')"
              v-model="searchText"
              class="form-control text-center"
            />
            <span class="input-group-btn">
              <button type="button" class="btn btn-primary ">
                <i class="fa fa-search"></i>
              </button>
            </span>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="box box-primary">
            <div class="box-header with-border">
              <i class="fa fa-search"></i>
              <h3 class="box-title">
                <span>{{$ml.get('support.searchResults')}}</span>
              </h3>
            </div>
            <div class="box-body">
              <div
                v-show="helpList.length > 0"
                class="table-responsive no-padding"
                :style="windowHeightSize"
              >
                <table class="table table-hover">
                  <tbody>
                    <tr v-for="(help,index) in filtered" :key="index">
                      <td>{{help.anaBaslik}}</td>
                      <td>{{help.altBaslik}}</td>
                      <td class="pull-right">
                        <button
                          type="button"
                          @click="getHelp(help.link, help.anaBaslik, help.altBaslik)"
                          class="btn btn-primary btn-sm "
                        >
                          <i class="fa fa-search"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-show="helpList.length == 0" class="callout callout-info">
                <i class="fa fa-info-circle"></i> {{$ml.get('support.noRecordFound')}}
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoading">
            <i class="fa fa-refresh fa-spin"></i>
          </div>
          </div>
        </div>
        <div class="col-sm-8">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">
                <span>{{selectedBaslik}}</span>
              </h3>
            </div>
            <div class="box-body" align="center">
              <iframe
                width="100%"
                :height="windowVideoHeightSize"
                :src="selectedLink"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
            <div class="overlay" id="load" :hidden="!isLoadingDetail">
            <i class="fa fa-refresh fa-spin"></i>
          </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isLoading: false,
      isLoadingDetail: false,
      windowHeight: window.innerHeight,
      list: [],
      selectedLink: "",
      selectedBaslik: "",
      searchText: ""
    };
  },
  computed: {
    helpList() {
      return this.list;
    },
    filtered() {
      if (this.searchText) {
        return this.helpList.filter(item => {
          return this.searchText
            .toUpperCase()
            .split(" ")
            .every(v => item.etiketler.toUpperCase().includes(v));
        });
      } else {
        return this.helpList;
      }
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 360;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowVideoHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 360;
        return height;
      } else {
        return "400";
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    getHelp(link, anaBaslik, altBaslik) {
      this.isLoadingDetail = true;
      this.selectedBaslik = anaBaslik + " - " + altBaslik;
      this.selectedLink = link.replace("watch?v=", "embed/");
      this.isLoadingDetail = false;
    },
    async getHelps() {
      try {
        this.isLoading = true;
        const list = [];
        const response = await this.$axios
          .get("/Help")
          .then(response => {
            if (response.status == 200) {
              response.data.forEach(doc => {
                list.push({
                  anaBaslik: doc.anaBaslik,
                  altBaslik: doc.altBaslik,
                  link: doc.link,
                  etiketler: doc.etiketler
                });
              });
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.list = list;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoading = false;
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getHelps();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/help/Help.vue